import { styled } from "@mui/material";
export const AccountLevelContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  marginTop: "10px",
  width: "100%",
});

export const LevelContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  gap: "8px",
  alignItems: "center",
});

export const TextContainer = styled("div")({
  display: "flex",
  gap: "4px",
  alignItems: "flex-start",

  "& p": {
    fontSize: "12px",
    color: "var(--color-grey-40)",
    margin: 0,
  },
});

export const BaseLevelIndicator = styled("div")({
  marginTop: "4px",
  height: "8px",
  flex: 1,
  backgroundColor: "var(--color-grey-40)",

  "&:first-of-type": {
    borderRadius: "10px 0 0 10px",
  },
  "&:last-of-type": {
    borderRadius: "0 10px 10px 0",
  },
});
